export default "__VITE_ASSET__DfQ$YG3___"